import { render, staticRenderFns } from "./lectoParamsPrice.vue?vue&type=template&id=006f319e&scoped=true"
import script from "./lectoParamsPrice.vue?vue&type=script&lang=js"
export * from "./lectoParamsPrice.vue?vue&type=script&lang=js"
import style0 from "./lectoParamsPrice.vue?vue&type=style&index=0&id=006f319e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f319e",
  null
  
)

export default component.exports